<template>
  <div class="rangeA0009">
    <div class="header">
        <img src="../images/banner.png" alt="" width="100%" style="margin-bottom:15px;">
    </div>
    <p class="doc_title">WiFi万能钥匙用户安全理赔计划</p>
    <p class="doc_text">WiFi万能钥匙用户安全理赔计划是指WiFi万能钥匙用户在使用WiFi网络时，网上银行或第三方支付工具的账户发生财产非正常损失，若因WiFi万能钥匙导致，用户可以依据本保险计划的有关规则申请理赔。</p>

    <p class="doc_title">提供保障</p>
    <p class="doc_text">每人单日/单次最高赔付20000元<br>每人累计最高赔付100000元</p>

    <p class="doc_title">重要提示</p>
    <p class="doc_text">1.用户必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即用户必须安装WiFi万能钥匙女生版安卓版1.0.0以上版本及此后发布的更新版本）。</p>
    <p class="doc_text">2.向WiFi万能钥匙提供真实有效的信息，且该信息与受保障的实名账户持有人信息一致。</p>
  </div>
</template>

<script>
export default {
  name: 'rangeA0009',
  mounted:function(){
    // Utils.Tracker.send({
    //     data: {
    //         f: 'wifiins',
    //         b: 'ins_detail_A0009'
    //     }
    // });
    this.$trace.enterTraceDone({ page: 6,  type: 'rangeA0009'})
  }
}
</script>

<style scoped>
.doc_title{margin-top: 0;margin-bottom: 10px;padding-top: 0;}
</style>



// WEBPACK FOOTER //
// rangeA0009.vue?5fc27272